import React, { Fragment } from 'react'
import _Input from './Input/Input'
import Label from './Input/Label'
import RichTextEditor from '../RichTextEditor/RichTextEditor'

export const Input = ({ label, labelStyle, onValueChange, isHtmlFormatted, length, onChange, required, autoFocus, preventSubmit, ...props }) => {
  let data = props.data ?? props.value
  const {
    placeholder,
    textAreaRows,
    helpText,
    helpTextTools,
    style,
    imageUploadFunc,
    imageUploadPath,
    mentionGroup,
    mentionField,
    cmpId,
    config,
    words,
    icon
  } = props
  return (
    // <_Input
    //   type='textarea'
    //   rows={rows}
    //   label={label}
    //   value={data}
    //   onChange={(e) => {
    //     onChange && onChange(e)
    //     onValueChange && onValueChange(e.target.value)
    //   }}
    // />
    <Fragment>
      {isHtmlFormatted
        ? (<div className={'position-relative w-100 input-wrapper'}>
          <Label required={required} label={label} {...props} />
          <RichTextEditor
            {...props}
            error={props.error}
            required={required}
            onChange={(e) => {
              onChange && onChange(e)
              onValueChange && onValueChange(e)
            }}
            placeholder={placeholder}
            html={data || ''}
            height={textAreaRows}
            width={'100%'}
            style={{ borderRadius: '.25rem' }}
            imageUploadFunc={imageUploadFunc}
            imageUploadPath={imageUploadPath}
            cmpId={cmpId}
            config={config}
            mentionGroup={mentionGroup}
            mentionField={mentionField}
            preventSubmit={preventSubmit}
          />
        </div>)
        : (
          <_Input
            {...props}
            style={style}
            type='textarea'
            rows={textAreaRows}
            label={label}
            labelStyle={labelStyle}
            value={data}
            required={required}
            onChange={(e) => {
              onChange && onChange(e)
              onValueChange && onValueChange(e.target.value)
            }}
            helpText={helpText}
            helpTextTools={helpTextTools}
            autoFocus={autoFocus}
            config={config}
            words={words}
            placeholder={placeholder}
            icon={icon}
          />)
      }
    </Fragment>
  )
}

export const Output = props => {
  let data = props.data ?? props.value
  return (
    <div
      style={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        margin: 0,
        whiteSpace: props.isHtmlFormatted ? 'normal' : 'pre-wrap'
      }}
      dangerouslySetInnerHTML={{ __html: data }}
    />
  )
}
